import styles from './Toggle.module.css'

interface Props {
  attivo: boolean
  onChange: (nuovoStato: boolean) => void
  etichetta?: string
  disabilitato?: boolean
}

export function Toggle({ attivo, onChange, etichetta, disabilitato }: Props) {
  return (
    <label className={styles.wrap}>
      <button
        type="button"
        role="switch"
        aria-checked={attivo}
        disabled={disabilitato}
        className={`${styles.toggle} ${attivo ? styles.on : ''}`}
        onClick={() => onChange(!attivo)}
      >
        <span className={styles.thumb} />
      </button>
      {etichetta && <span className={styles.lbl}>{etichetta}</span>}
    </label>
  )
}
